module.exports = "https://web-assets.ifttt.com/packs/media/header/maker_header-43a1b6a4.svg";